import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../../data/content";
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="questions" aria-labelledby="questions-title" className="scroll-mt-20 border-t border-white/10 bg-navy-800" data-id="element-105" data-mp="zrqb3at93dgp">
      <div className="container-x grid gap-10 py-14 sm:py-20 lg:grid-cols-12 lg:gap-16 lg:py-28" data-id="element-106" data-mp="70ot71y6b3th">
        <div className="lg:col-span-4" data-id="element-107" data-mp="22n7sad9yseu">
          <p className="eyebrow" data-id="element-108" data-mp="23olynpl7v0s">Questions</p>
          <h2 id="questions-title" className="section-title mt-4" data-id="element-109" data-mp="gz4l3750yh41">
            Before you <span className="text-cyan" data-id="element-110" data-mp="gx1kxua5r7ll">plan with it</span>
          </h2>
          <p className="mt-6 max-w-[26rem] text-[17px] leading-[1.7] text-ice/80" data-id="element-111" data-mp="byqcnnzih55h">
            Straight answers about what the book includes, and what it isn’t.
          </p>
        </div>

        <ul className="border-t-2 border-cyan lg:col-span-8" data-id="element-112" data-mp="1neop81twe9bg">
          {faqs.map((faq, i) => {
          const open = openIndex === i;
          return <li key={faq.question} className="border-b border-white/10" data-id="element-113" data-mp="msaq6gecga9j" data-mpi={i}>
                <h3 data-id="element-114" data-mp="mun3gg95pwg9">
                  <button type="button" id={`faq-button-${i}`} aria-expanded={open} aria-controls={`faq-panel-${i}`} onClick={() => setOpenIndex(open ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left text-[16px] font-bold text-ice sm:gap-6 sm:py-6 sm:text-lg" data-id="element-115" data-mp="rrdlva8fp44u">
                    <span data-id="element-116" data-mp="82cxbn5gywe0">{faq.question}</span>
                    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full border transition-[transform,background-color,border-color,color] duration-200 ease-out ${open ? "rotate-45 border-cyan bg-cyan text-navy" : "border-cyan/40 text-cyan"}`} aria-hidden="true" data-id="element-117" data-mp="cumm2zuulqep">
                      <PlusIcon className="h-4 w-4" data-id="element-118" data-mp="iqfpotu466ye" />
                    </span>
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-119" data-mp="xe0ssnqzo66b">
                  {open && <motion.div id={`faq-panel-${i}`} role="region" aria-labelledby={`faq-button-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-120" data-mp="sffu4srdxujz">
                      <p className="max-w-[62ch] pb-6 pr-2 text-[15px] leading-relaxed text-ice/80 sm:pb-7 sm:pr-12 sm:text-base" data-id="element-121" data-mp="1p5p1n0ak6ake">{faq.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}